import React from 'react';
import './LaNeuropsychologie.scss';

/**
 * Page explicative sur la discipline et ses deux piliers (Évaluation & Accompagnement).
 */
const LaNeuropsychologie = () => {
  return (
    <div className="neuro-page container">
      <header className="page-header">
        <h1>Qu’est-ce que la neuropsychologie ?</h1>
        <p className="subtitle">Le neuropsychologie est une spécialité de la psychologie.</p>
      </header>

      <section className="definition-box">
        <p>
          Elle permet l’étude des liens entre le <strong>fonctionnement cérébral</strong>, la 
          <strong> cognition</strong> (mémoire, attention, planification, etc.) et le 
          <strong> comportement humain</strong>.
        </p>

        <div className="degree-info">
          <h3>🎓 Le titre protégé de psychologue</h3>
          <p>
            Le psychologue spécialisé en neuropsychologie est porteur d’un titre protégé. Il est 
            titulaire d’une Licence et d’un Master de psychologie, ce qui correspond à 5 années d’études supérieures.
          </p>
        </div>
      </section>

      <section className="missions-section">
        <h2>Le psychologue spécialisé en neuropsychologie a deux missions principales :</h2>

        <div className="missions-grid">
          <div className="mission-card">
            <div className="mission-badge">Mission 1</div>
            <h3>L’évaluation</h3>
            <p>
              Le psychologue évalue <strong>le fonctionnement</strong> du patient (intellectuel, cognitif et émotionnel).
            </p>
            <p>
              Le bilan neuropsychologique permet d’évaluer de manière précise les capacités cognitives telles 
              que la mémoire, l’attention, le langage, les fonctions exécutives ou le raisonnement ainsi que 
              leur retentissement dans la vie quotidienne.
            </p>
            <p className="mission-goal">
              💡 Il offre une compréhension fine <strong>des ressources et des difficultés</strong> au quotidien afin 
              d’orienter un accompagnement adapté et <strong>d’améliorer la qualité de vie</strong> du patient.
            </p>
          </div>

          <div className="mission-card">
            <div className="mission-badge">Mission 2</div>
            <h3>L’accompagnement</h3>
            <p>
              Le psychologue accompagne <strong>le patient et son entourage</strong> à travers plusieurs prises en charge : 
              remédiation cognitive, psychoéducation, accompagnement des familles et des proches, psychothérapie.
            </p>
            <p>
              Il fait également du lien avec d’autres professionnels, notamment ceux inscrits dans le 
              parcours de soin du patient :
            </p>
            <ul className="partners-list">
              <li>Médecin traitant</li>
              <li>Neurologue</li>
              <li>Psychiatre</li>
              <li>Orthophoniste</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LaNeuropsychologie;